import { motion } from 'framer-motion';
import styled from 'styled-components';
import SingleCup from '../../../assets/images/pong/cup-1.png';
import DoubleCup from '../../../assets/images/pong/cup-2.png';
import TrippleCup from '../../../assets/images/pong/cup-3.png';
import { StyledButton } from '../../../common/Button/styles';
import { Backdrop } from './BackDrop';

export const Root = styled('div')`
  margin-top: -20%;
  padding: 30px;
  backdrop-filter: blur(10px);
  border-radius: 10px;
  text-align: center;

  .modal-title {
    font-size: 52px;
    text-shadow: 3px 3px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff,
      -1px 1px 0 #fff, 1px 1px 0 #fff;
    color: #e02f29 !important;
    margin-bottom: 30px;

    @media only screen and (max-width: 600px) {
      font-size: 25px;
    }
  }
  @media only screen and (max-width: 600px) {
    margin-top: -40%;
    padding: 0px !important;
  }

  .list {
    // margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    border: 5px solid #ffffff2b;
    padding-left: 20px;
    padding-right: 35px;
    padding-top: 25px;
    padding-bottom: 5px;

    h4 {
      font-size: 20px;
      span {
        font-size: 140%;
        font-weight: bolder;
        text-shadow: 2px 1px #e02f29, -1px -1px #e02f29;
      }
      @media only screen and (max-width: 600px) {
        font-size: 12px;
      }
    }
    img {
      max-height: 46px;
      margin-top: -30px;
      @media only screen and (max-width: 600px) {
        max-height: 30px;
        margin-top: -5px;
      }
    }
  }
  .one {
    border-bottom: none;
    border-radius: 10px 10px 0 0;
  }
  .three {
    border-top: none;
    border-radius: 0 0 10px 10px;
  }
  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    gap: 5px;
    text-transform: lowercase;
    margin-top: 30px;
    margin-bottom: 10px;
    cursor: pointer;

    input {
      width: inherit;
    }
  }
`;
const Button = styled(StyledButton)`
  border-radius: 10px;
  font-size: 20px;
  padding: 7px 20px;
  @media only screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

interface IGameInstructions {
  handleClose: () => void;
  isOpen: boolean;
}

const dropIn = {
  hidden: {
    y: '-100vh',
    opacity: 0,
  },
  visible: {
    y: '0',
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: '100vh',
    opacity: 0,
  },
};

export const GameInstructions = ({
  handleClose,
  isOpen,
}: IGameInstructions) => {
  return (
    <Backdrop onClick={handleClose}>
      <motion.div
        onClick={(e) => e.stopPropagation()}
        className='modal orange-gradient'
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
      >
        <Root>
          <h3 className='modal-title'>How It Works</h3>
          <div className='modal-body'>
            <div className='list one'>
              <img src={SingleCup} />
              <h4>
                With <span>1</span> throw, payout <span>2x</span> (chance{' '}
                <span>50%</span>)
              </h4>
            </div>
            <div className='list '>
              <img src={DoubleCup} />
              <h4>
                With <span>2</span> throws, payout <span>4x</span> (chance{' '}
                <span>50%</span>)
              </h4>
            </div>
            {/* <div className='list three'>
              <img src={TrippleCup} />
              <h4>
                With <span>3</span> throws, payout <span>3x</span> (chance{' '}
                <span>35%</span>)
              </h4>
            </div> */}
          </div>
          <label className='checkbox'>
            <input
              type='checkbox'
              onChange={(e) =>
                window.localStorage.setItem(
                  'playRule',
                  JSON.stringify(e.target.checked)
                )
              }
            />{' '}
            <span>Don't show this again.</span>
          </label>
          <Button onClick={handleClose} whileHover={{ scale: 1.1 }}>
            Accept and Continue
          </Button>
        </Root>
      </motion.div>
    </Backdrop>
  );
};
